import { forwardRef, useContext } from "react";
import type { ComponentProps } from "react";
import { chakra } from "@chakra-ui/react";
import { IconContext } from "../IconContext";
const KeyboardArrowLeftOutlinedIcon = forwardRef<SVGSVGElement, Omit<ComponentProps<typeof chakra["svg"]>, "minWidth" | "width" | "maxWidth" | "minHeight" | "height" | "maxHeight" | "__css"> & {
  size?: "xs" | "sm" | "md" | "lg";
}>(({
  size: sizeProp,
  ...rest
}, ref) => {
  const iconContext = useContext(IconContext);
  const size = sizeProp || iconContext.size;
  const width = {
    xs: "0.875rem",
    sm: 4,
    md: 5,
    lg: 6
  }[size];
  const props = {
    ...rest,
    minWidth: width,
    width,
    maxWidth: width,
    minHeight: width,
    height: width,
    maxHeight: width,
    fill: rest.fill || "currentColor"
  } as ComponentProps<typeof chakra["svg"]>;
  return <chakra.svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 -960 1080 1080" __css={{
    "& > *": {
      "transform": "translate(60px,60px)"
    }
  }} ref={ref} {...props}><path d="M561-216 296-481l265-265 67 67-198 198 198 198-67 67Z" /></chakra.svg>;
});
export default KeyboardArrowLeftOutlinedIcon;